import {fetch} from '@/utils/fetch';

/**
 * 查询列表
 * @returns {Promise<Response>}
 */
export function _queryBizCompanys(
  {
    page, size, direction, sort,customName,bindStatus
  },
) {
  return fetch({
    url: `${ process.env.VUE_APP_BASE_URL }/biz-companys`,
    method: 'get',
    params: {
      page,
      size,
      direction,
      sort,
      customName,
      bindStatus
    },
  });
}
/**
 * 查询列表
 * @returns {Promise<Response>}
 */
export function _queryBizCompanyList() {
  return fetch({
    url: `${ process.env.VUE_APP_BASE_URL }/biz-companys-list`,
    method: 'get',
  });
}

/**
 * 根据 id 查询
 * @returns {Promise<Response>}
 */
export function _queryBizCompany(bizCompanyId) {
  return fetch({
    url: `${ process.env.VUE_APP_BASE_URL }/biz-companys/${ bizCompanyId }`,
    method: 'get',
  });
}

/**
 * 新增
 * @param  id
 * @param  createUserId
 * @param  updateUserId
 * @param  name
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _addBizCompany({createUserId, updateUserId, name,number}) {
  return fetch({
    url: `${ process.env.VUE_APP_BASE_URL }/biz-companys`,
    method: 'post',
    data: {
      createUserId,
      updateUserId,
      name,
      number
    },
  });
}

/**
 * 更新
 * @param bizCompanyId
 * @param  id
 * @param  createAt
 * @param  updateAt
 * @param  createUserId
 * @param  updateUserId
 * @param  name
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _updateBizCompany(bizCompanyId, {
  id,
  createUserId,
  updateUserId,
  name,
  number,
}) {
  return fetch({
    url: `${ process.env.VUE_APP_BASE_URL }/biz-companys/${ bizCompanyId }`,
    method: 'patch',
    data: {
      id,
      createUserId,
      updateUserId,
      name,
      number,
    },
  });
}

/**
 * 删除
 * @param bizCompanyId
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _deleteBizCompany(bizCompanyId) {
  return fetch({
    url: `${ process.env.VUE_APP_BASE_URL }/biz-companys/${ bizCompanyId }`,
    method: 'delete',
  });
}

export default {};
